import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {MatAutocomplete} from '@angular/material/autocomplete';
import {MatSelectChange} from '@angular/material/select';
import {ErrorStateMatcher} from '@angular/material/core';

@Component({
  selector: 'form-input',
  templateUrl: './form-input.component.html',
  styleUrls: ['./form-input.component.scss']
})
export class FormInputComponent implements OnInit {

  @Input() control!: FormControl;
  @Input() formGroup?: FormGroup;
  @Input() type = 'text';
  @Input() label = 'Input';
  @Input() hint: string | undefined;
  @Input() placeholder: string | undefined;
  @Input() autocomplete: string | undefined;
  @Input() required = true;
  @Input() compact = false;
  @Input() textAreaHeight = '100%';

  @Input() inProgress = false;

  @Input() options?: any[];
  @Input() compareWith!: (o1: any, o2: any) => boolean;
  @Input() displayWith!: (option: any) => string;

  @Input() autoComplete: MatAutocomplete | null = null;

  @Input() min: number | undefined;
  @Input() max: number | undefined;
  @Input() minLength: number | undefined;
  @Input() maxLength: number | undefined;

  @Input() errorStateMatcher: ErrorStateMatcher | undefined;
  @Input() timeErrorCode: string | undefined;
  @Input() timeStart: boolean = true;

  @Input() suffixButton: string | undefined;
  @Input() suffixButtonAlt: string | undefined;
  @Input() suffixAction?: () => void;
  suffixUsed: boolean | undefined;

  @Input() suffixIcon: string | undefined;
  @Input() suffixTooltip = '';

  @Input() name: string | undefined;

  @Output() optionChanged = new EventEmitter<any>();
  @Output() focusLost = new EventEmitter<any>();
  @Output() keyUpEnter = new EventEmitter<any>();

  @ViewChild('input', {static: false}) inputElement!: ElementRef;

  constructor() {
  }

  ngOnInit(): void {
  }

  get inputType(): string {
    return !this.suffixButton
      ? this.type
      : this.type == 'password' && this.suffixUsed ? 'text' : this.type;
  }

  get detailName(): string {
    return this.name || this.label;
  }

  useSuffixBtn() {
    if (this.suffixAction) {
      this.suffixAction();
    } else {
      this.suffixUsed = !this.suffixUsed;
    }
  }

  public setFocus() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
    this.inputElement.nativeElement.focus();
  }

  optionSelected(change: MatSelectChange) {
    this.optionChanged.emit(change.value);
  }

  handleOnBlur() {
    this.focusLost.emit();
  }

  handleKeyUpEnter() {
    this.keyUpEnter.emit();
  }
}
